import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSession } from "../../../hooks/useSession";
import { useAppointmentResponse } from "../../../hooks/useAppointmentResponse";
import { useDynatrace } from "../../../hooks/useDynatrace";

export const useDatiPersonaliNonRiconosciutoBusinessPage = () => {
  const { state } = useLocation();
  const { read, update } = useSession();
  const { handleAppointmentBusinessSubmission, isCreaAppuntamentoBusy, isCreaAppuntamentoError, fetchErrorMessage, fetchError, setFetchError } = useAppointmentResponse();

  const [lockFields, setLockFields] = useState(false);

  useEffect(() => {
    setLockFields(state && state.lockFields);
    update("utenteRiconosciuto", false);
  }, []);

  const {} = useDynatrace();

  const next = async () => {
    handleAppointmentBusinessSubmission();
  };

  const onNomeChange = (value) => {
    update("nome", value);
  };
  const onCognomeChange = (value) => {
    update("cognome", value);
  };
  const onEmailChange = (value) => {
    update("email", value);
  };
  const onCellulareChange = (value) => {
    update("cellulare", value);
  };

  return {
    next,
    read,
    update,
    onNomeChange,
    onCognomeChange,
    onEmailChange,
    onCellulareChange,
    lockFields,
    isCreaAppuntamentoBusy,
    isCreaAppuntamentoError,
    fetchErrorMessage,
    fetchError,
    setFetchError,
  };
};
